import React, { Component } from "react";
import { Table, Button, Input, Col, Row, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import numeral from "numeral";
import ProdutoFiltroForm from '../components/ProdutoFiltroForm';
import EstoqueAtualPrintModal from "../relatorios/EstoqueAtualPrintModal";
import Colors from '../utils/Colors';

const { Column } = Table;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdeEstoque: 0,
    vlrCusto: 0,
    vlrVenda: 0,
    // vlrTotalEstoque: 0,

    filtros: {
      tipoTela: 'EA',
      buscaOrdem: { campo: 'prod_descricao', ordem: 'ASC' },
      buscaProduto: { key: '0' },
      buscaMarca: { key: '0' },
      buscaGrupo: { key: '0' },
      buscaSituacao: { key: '1' },
      buscaEstoqueBaixo: 0,
    }
  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      },
        this.getListaRegistros
      )
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite } = this.state;
    const { buscaProduto, buscaMarca, buscaGrupo, buscaSituacao, buscaEstoqueBaixo, buscaOrdem } = this.state.filtros;

    // console.log('getListaRegistros: ', this.state);
    axios
      .get('/estoque/listaEstoqueAtual', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          produto: buscaProduto.pest_item,
          tamanho: buscaProduto.pest_tamanho,
          cor: buscaProduto.pest_cor,
          marca: buscaMarca.key,
          grupo: buscaGrupo.key,
          situacao: String(buscaSituacao.key),
          estoqueBaixo: buscaEstoqueBaixo
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.consulta;
        this.setState({
          listaRegistros: data,

          // vlrTotalEstoque: response.data.vlrTotalEstoque,
          qtdeEstoque: response.data.qtdeEstoque,
          vlrCusto: response.data.vlrCusto,
          vlrVenda: response.data.vlrVenda,

          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };

  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaMarca: this.state.filtros.buscaMarca,
        buscaGrupo: this.state.filtros.buscaGrupo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaEstoqueBaixo: this.state.filtros.buscaEstoqueBaixo,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderValorCusto = (registro) => {
    return (
      <span> {numeral(registro.pest_qtde * registro.prod_vlr_custo).format('0,000.00')} </span>
    );
  };

  renderPercEst = (registro) => {
    return (
      <span> {numeral((registro.pest_qtde * registro.prod_vlr_custo * 100) / this.state.vlrCusto).format('0,000.00')} </span>
    );
  };

  renderValorVenda = (registro) => {
    return (
      <span> {numeral(registro.pest_qtde * registro.prod_vlr_venda).format('0,000.00')} </span>
    );
  };

  renderSituacao = (prod_situacao) => {
    return (
      <span> {prod_situacao === 1 ? 'ATIVO' : 'INATIVO'} </span>
    );
  };

  renderDescricao = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, total, pagina, limite, filtros, formFiltroVisivel } = this.state;

    // console.log('EstoqueAtualPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Estoque Atual</span>
        <div className="divider-page1" />

        <Row>
          <Col xs={2} style={{ width: 110, marginBottom: 10 }}>
            <Button
              type="primary"
              onClick={this.onAbrirFiltroClick}
              className="botao-primary"
              style={{ marginRight: 15 }}
            >
              Filtrar
            </Button>
          </Col>
          <Col xs={2} style={{ width: 110 }}>
            <EstoqueAtualPrintModal
              filtros={filtros}
              totalVendas={this.state.totalVendas}
              qtdeVendas={this.state.qtdeVendas}
            />
          </Col>
          <ProdutoFiltroForm
            visivel={formFiltroVisivel}
            onFiltrarClick={this.onFiltrarClick}
            onCancelarFiltroClick={this.onCancelarFiltroClick}
            filtros={filtros}
          />
        </Row>

        <Row>
          <Col xs={24} md={24} style={{ height: 65, padding: 5, marginTop: -15 }}>
            <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
              <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                  <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                    Qtde Estoque
                  </span>
                </Row>
                <Row style={{ textAlign: "center" }}>
                  <Row style={{ marginTop: -5 }}>
                    <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.qtdeEstoque)}</span>
                  </Row>
                </Row>
              </div>
            </Col>
            <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
              <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                  <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                    Valor Custo
                  </span>
                </Row>
                <Row style={{ textAlign: "center" }}>
                  <Row style={{ marginTop: -5 }}>
                    <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrCusto)}</span>
                  </Row>
                </Row>
              </div>
            </Col>
            <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
              <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                  <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                    Valor Venda
                  </span>
                </Row>
                <Row style={{ textAlign: "center" }}>
                  <Row style={{ marginTop: -5 }}>
                    <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrVenda)}</span>
                  </Row>
                </Row>
              </div>
            </Col>
          </Col>
          {/* <Col xs={24} sm={11} style={{ background: Colors.background, padding: 5, marginTop: 0 }}>
            <Col xs={24} sm={8} style={{ marginRight: 5, textAlign: "center", background: "white", marginLeft: 5 }} >
              <Row><span style={{ fontWeight: "bold" }}>Qtde Estoque</span></Row>
              <Row><span>{this.renderValor(this.state.qtdeEstoque)}</span></Row>
            </Col>
            <Col xs={24} sm={8} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
              <Row><span style={{ fontWeight: "bold" }}>Valor Custo</span></Row>
              <Row><span>R$ {this.renderValor(this.state.vlrCusto)}</span></Row>
            </Col>
            <Col xs={24} sm={7} style={{ marginRight: 0, textAlign: "center", background: "white" }} >
              <Row><span style={{ fontWeight: "bold" }}>Valor Venda</span></Row>
              <Row><span>R$ {this.renderValor(this.state.vlrVenda)}</span></Row>
            </Col>
          </Col> */}
        </Row>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          rowKey={(registro => registro.prod_idf + '_' + registro.pest_tamanho + '_' + registro.pest_cor)}
        >
          <Column
            key="prod_codigo"
            dataIndex="prod_codigo"
            title={this.renderTitulo("Código")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={60}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="prod_descricao"
            dataIndex="prod_descricao"
            title={this.renderTitulo("Descrição")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={150}
            align="left"
            className="listaCadastro"
            render={this.renderDescricao}
          />
          <Column
            key="mar_descricao"
            dataIndex="mar_descricao"
            title={this.renderTitulo("Marca")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="grp_descricao"
            dataIndex="grp_descricao"
            title={this.renderTitulo("Grupo")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="prod_situacao"
            dataIndex="prod_situacao"
            title={this.renderTitulo("Situação")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={60}
            align="left"
            className="listaCadastro"
            render={this.renderSituacao}
          />
          <Column
            key="pest_qtde"
            dataIndex="pest_qtde"
            title={this.renderTitulo("Qtde Atual")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderValor}
          />
          <Column
            key="prod_vlr_custo"
            dataIndex="prod_vlr_custo"
            title={this.renderTitulo("Vlr Custo")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderValor}
          />
          <Column
            key=""
            dataIndex=""
            title={this.renderTitulo("Total Custo")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderValorCusto}
          />
          <Column
            key=""
            dataIndex=""
            title={this.renderTitulo("% no Estoque")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderPercEst}
          />
          <Column
            key="prod_vlr_venda"
            dataIndex="prod_vlr_venda"
            title={this.renderTitulo("Vlr Venda")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderValor}
          />
          <Column
            // key="prod_vlr_venda"
            // dataIndex="prod_vlr_venda"
            title={this.renderTitulo("Total Venda")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderValorVenda}
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EstoqueAtualPage.js